import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  isApiErrorWithStatus,
  register as registerRequest,
  showApiError,
} from '~/services';
import { saveAccessToken, saveRefreshToken } from '~/utils/storage';
import { userSetData } from '~/store/user/slices';
import { mapApiUserToState } from '~/store/user/mappers';
import { loginSuccess } from '~/store/auth/login/slices';

import {
  registerFailure,
  registerRequest as registerStart,
  registerSuccess,
} from './slices';
import type { propsRequestRegister } from './interfaces';

export const registerUser = createAsyncThunk(
  'register/auth',
  async (payload: propsRequestRegister, { dispatch }): Promise<boolean> => {
    dispatch(registerStart());
    try {
      const { status, data } = await registerRequest({
        email: payload.email,
        password: payload.password,
        fullName: payload.name,
        phone: payload.phone.replace(/\D/g, ''),
        document: payload.document.replace(/\D/g, ''),
        farmName: payload.farmName,
        activity: payload.activity,
        hectares: payload.hectares ? Number(payload.hectares) : undefined,
        livestockHeadCount: payload.livestockHeadCount
          ? Number(payload.livestockHeadCount)
          : undefined,
        annualRevenueCents: Math.round(
          Number(
            (payload.annualRevenue ?? '0').toString().replace(/\D/g, ''),
          ),
        ),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      });

      if (status === 200 || status === 201) {
        saveAccessToken(data.tokens.accessToken);
        saveRefreshToken(data.tokens.refreshToken);
        dispatch(userSetData(mapApiUserToState(data.user)));
        dispatch(loginSuccess());
        dispatch(registerSuccess());
        return true;
      }

      dispatch(registerFailure());
      return showApiError(new Error('Unexpected register response'));
    } catch (error) {
      dispatch(registerFailure());
      if (isApiErrorWithStatus(error, 409)) {
        return showApiError(error, {
          title: 'Conta já cadastrada',
          description:
            'Já existe uma conta com este email ou documento.\nFaça login para continuar.',
        });
      }
      return showApiError(error);
    }
  },
);
